import {Button} from '@vector';
import styles from './PricingPanel.module.css';

/**
 * Pricing card for brands whose only price is a school rate written in their content: South Africa (a guide
 * rate, with "Request a quote") and India (a per-student rate, with "Register").
 *
 * Same card as `PricingPanel`, without its audience switch and live product prices: these brands sell no card
 * products, so there is nothing to fetch and nothing to switch between. `body` and `footnote` are optional.
 */
export default function SchoolPricePanel({content}) {
    return (
        <div className={styles.card}>
            <div className={styles.head}>
                <h2 className={styles.heading}>{content.heading}</h2>
            </div>

            {content.body && <p className={styles.hint}>{content.body}</p>}

            <div className={styles.figure}>
                <p className={styles.price}>{content.schoolPrice}</p>
                <p className={styles.priceNote}>{content.schoolNote}</p>
            </div>

            <div className={styles.footer}>
                <Button surface="base" size="large" href={content.action.href}>
                    {content.action.label}
                </Button>
                {content.footnote && <p className={styles.hint}>{content.footnote}</p>}
            </div>
        </div>
    );
}
